import { OverviewSummary } from "../@types/report";

export const calculateProfit = (v: OverviewSummary) =>
	v.depositTotal - (v.affiliateTotal + v.cashbackTotal + v.wheelTotal + v.promotionTotal + v.withdrawTotal.success)

export const calculateNewProfit = (v: OverviewSummary) => v.depositTotal - v.withdrawTotal.success

export const depositAndbonus = (v: OverviewSummary) => v.depositTotal + v.promotionTotal